import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteMediaAsset,
  listMediaAssets,
  uploadMediaAsset,
} from '../services/media-library.service';
import type { MediaLibraryFilter } from '../types/media-library.types';

export const MEDIA_LIBRARY_QUERY_KEY = 'media-library';

export const useMediaLibrary = (filter: MediaLibraryFilter = {}) => {
  return useQuery({
    queryKey: [MEDIA_LIBRARY_QUERY_KEY, filter.search, filter.type],
    queryFn: () => listMediaAssets(filter),
    staleTime: 30 * 1000,
  });
};

export const useUploadMedia = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => uploadMediaAsset(file),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [MEDIA_LIBRARY_QUERY_KEY] });
    },
  });
};

export const useDeleteMedia = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileId: string) => deleteMediaAsset(fileId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [MEDIA_LIBRARY_QUERY_KEY] });
    },
  });
};
